import { render, staticRenderFns } from "./sign_up_arkose_app.vue?vue&type=template&id=07a47e0c"
import script from "./sign_up_arkose_app.vue?vue&type=script&lang=js"
export * from "./sign_up_arkose_app.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports